const LoadingSpinner = () => {
	return (
		<div className="flex items-start justify-center">
			<div className="h-16 w-16 animate-spin rounded-full border-4 border-dashed border-blue-600"></div>
		</div>
	)
}

export default LoadingSpinner
